import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import classNames from 'classnames';
import React from 'react';
import { MiroLogo } from '@mirohq-internal/website-ui-foundation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BrandAttributionBlock = function BrandAttributionBlock(_ref) {
  var _Date, _classNames;

  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size;
  var year = ((_Date = new Date()) === null || _Date === void 0 ? void 0 : _Date.getFullYear()) || '';
  return /*#__PURE__*/_jsxs("div", {
    className: "d-inline-flex align-items-end gap-100",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(MiroLogo.Emblem, {
        className: classNames('icon', (_classNames = {}, _defineProperty(_classNames, "icon-size", !size), _defineProperty(_classNames, "icon-size-".concat(size), size), _classNames))
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames('text-nowrap', {
        'display-6': size === 'lg',
        p: size === 'md',
        small: size === 'sm'
      }),
      children: ["Miro \xA9 ", year]
    })]
  });
};